export interface MiniApp {
  id: string;
  name: string;
  description: string;
  icon: string;
  url: string;
  requiresAuth?: boolean;
  useDeepLink?: boolean;
  deepLinkScheme?: string;
}

export interface MiniAppSession {
  appId: string;
  lastLoginTime: number;
  sessionExpiry: number;
}

export const MINI_APPS: MiniApp[] = [
  {
    id: 'ctrader',
    name: 'cTrader',
    description: 'Access your cTrader trading platform',
    icon: 'https://lbvhywxvthwgiebjsrlr.supabase.co/storage/v1/object/public/logoexchangeplatformurl/logo_ctrader.png',
    url: 'https://ct.spotware.com',
    useDeepLink: true,
    deepLinkScheme: 'ctrader://open',
    requiresAuth: false
  },
  {
    id: 'aiprop-app',
    name: 'AI Prop App',
    description: 'AI-powered prop trading platform',
    icon: 'https://lbvhywxvthwgiebjsrlr.supabase.co/storage/v1/object/public/logoexchangeplatformurl/AI%20vuong%20logo%20trang.png',
    url: 'https://app.aiprop.com',
    requiresAuth: true
  },
  {
    id: 'aiprop-affiliate',
    name: 'AI Prop Aff',
    description: 'Manage your affiliate program',
    icon: 'https://lbvhywxvthwgiebjsrlr.supabase.co/storage/v1/object/public/logoexchangeplatformurl/AI%20PROP%20logo%20ICON.png',
    url: 'https://aiprop.com/affiliate-area/',
    requiresAuth: true
  },
  {
    id: 'edu-hub',
    name: 'Edu Hub',
    description: 'Educational trading resources',
    icon: 'https://lbvhywxvthwgiebjsrlr.supabase.co/storage/v1/object/public/logoexchangeplatformurl/EDU%20HUB.png',
    url: 'https://edu.tradebot365.com/',
    requiresAuth: false
  }
];
